<template>
  <span>
    <span key="empty-period" v-if="isEmpty">
      {{ emptyText }}
    </span>
    <span key="has-period" v-else>
      <span class="start">{{ startText }}</span>
      <span class="dash px-1">{{ dash }}</span>
      <span class="end">{{ endText }}</span>
    </span>
  </span>
</template>

<script>
export default {
  name: 'AppPeriod',
  props: {
    start: String,
    end: String,
    dash: {
      type: String,
      default: '-',
    },
    emptyText: {
      type: String,
      default: '使用期限なし',
    },
    isDate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formatter() {
      return this.isDate
        ? this.$options.filters.formatDate
        : this.$options.filters.formatTime
    },
    startText() {
      return this.formatter(this.start)
    },
    endText() {
      return this.formatter(this.end)
    },
    isEmpty() {
      return !this.start && !this.end
    },
  },
}
</script>
